<template>
  <v-container fluid>
    <v-row>
      <v-col class="text-h3 gray--text"> Criar Solicitação</v-col>

      <v-col cols="auto">
        <v-btn
          color="gray lighten-1"
          dark
          :to="`/prontuario/${attendance.id}/solicitacao-exames`"
        >
          voltar
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-row align="center">
          <v-col class="text-h5 gray--text auto"> Descrição </v-col>

          <v-col cols="auto">
            <v-switch
              v-model="emergency"
              dense
              class="v-input--reverse font-weight-bold"
            >
              <template #label>
                <span> Urgência </span>
              </template>
            </v-switch>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="3">
            <v-combobox
              label="Solicitante"
              v-model="requester"
              dense
              :hide-details="!errors.requester"
              :error-messages="errors.requester"
              outlined
              :items="doctorUsers"
              item-text="employee.name"
              background-color="white"
            />
          </v-col>

          <v-col cols="3">
            <v-combobox
              label="Encaminhar para"
              v-model="forwardTo"
              dense
              outlined
              clearable
              :items="doctorUsers"
              :hide-details="!errors.forwardTo"
              :error-messages="errors.forwardTo"
              item-text="employee.name"
              background-color="white"
            />
          </v-col>

          <v-col cols="3">
            <v-combobox
              label="CID"
              v-model="cid"
              dense
              :hide-details="!errors.cid"
              :error-messages="errors.cid"
              :items="onlyCids"
              item-text="codeDescription"
              outlined
              @change="changeCid"
              background-color="white"
            />
          </v-col>

          <v-col cols="1.5">
            <v-combobox
              label="Local"
              v-model="site"
              outlined
              dense
              :hide-details="!errors.site"
              :error-messages="errors.site"
              background-color="white"
              :items="sites"
              @change="changeSite"
            />
          </v-col>

          <v-col cols="1.5">
            <v-text-field
              label="Quantidade"
              v-model="requestedQuantity"
              dense
              :hide-details="!errors.requestedQuantity"
              :error-messages="errors.requestedQuantity"
              outlined
              type="number"
              min="1"
              background-color="white"
            />
          </v-col>
        </v-row>

        <v-row dense outlined>
          <v-col>
            <v-textarea
              label="Motivo"
              v-model="reason"
              v-uppercase
              dense
              outlined
              :hide-details="!errors.reason"
              :error-messages="errors.reason"
              background-color="white"
              style="height: 200px"
            />
          </v-col>

          <authorizationTwo
            permissionKey="observation_field"
            can="save"
            v-slot:default="{ authorization, isReadOnly, canSave }" >
            <template>
              <v-col 
              class="pt-1"
              v-if="isReadOnly || canSave">
                <v-textarea
                style="height: 30px"
                  class="pt-0 mt-0"
                  label="Observações"
                  v-model="observations"
                  v-uppercase
                  outlined
                  background-color="white"
                  :disabled="!canSave"
                />
              </v-col>
            </template>
          </authorizationTwo>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-row
          dense
          align="end"
          :class="errors.selectedsItems ? 'error--text' : ''"
        >
          <v-col
            cols="auto"
            :class="[
              'text-h5',
              errors.selectedsItems ? 'error--text' : 'gray--text',
            ]"
          >
            Exames
          </v-col>

          <v-spacer />

          <v-col cols="auto">
            {{ selectedsItems.length }} itens selecionados
          </v-col>
        </v-row>

        <v-row dense align="end" v-if="errors.selectedsItems">
          <v-col cols="auto" class="error--text">
            {{ errors.selectedsItems }}
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              label="Filtro"
              v-model="itemsFilter"
              dense
              outlined
              hide-details
              placeholder=" "
              clearable
              background-color="white"
            />
          </v-col>
          <v-col>
            <QuerySearchDropdown
              v-model="medicalRequestItemFacilitator"
              :query="getMedicalRequestItemFacilitatorsQuery"
              :query-key="['medicalRequestItemFacilitators', 'collection']"
              label="Aplicar Facilitador"
              item-text="title"
              not-found-text="Nenhum facilitador encontrado."
              @input="triggerFacilitator"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-tabs v-model="medicalRequestType" background-color="background">
              <v-tab key="exams">Exames</v-tab>
              <v-tab key="treatment">Tratamentos</v-tab>
              <v-tab key="surgery">Cirurgias</v-tab>
            </v-tabs>
          </v-col>

          <v-col cols="auto">
            <v-btn dark color="light-blue" @click="clearSelectedItems">
              Limpar Todos
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-tabs-items
              v-model="medicalRequestType"
              background-color="background"
              class="pb-2"
            >
              <v-tab-item key="exams">
                <v-card color="background">
                  <v-row :style="{ flexWrap: 'nowrap', overflowX: 'auto' }">
                    <v-col
                      cols="3"
                      v-for="(medicalRequestItemsCol,
                      index) in medicalRequestItemsExams"
                      :key="`medicalRequestItemsCol-${index}`"
                    >
                      <v-row
                        v-for="medicalRequestItem in medicalRequestItemsCol"
                        :key="medicalRequestItem.id"
                      >
                        <v-col>
                          <v-tooltip top max-width="450">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                :outlined="
                                  !selectedsItems.includes(medicalRequestItem)
                                "
                                :dark="
                                  selectedsItems.includes(medicalRequestItem)
                                "
                                block
                                rounded
                                color="light-blue"
                                @click="toggleItem(medicalRequestItem)"
                                :attrs="attrs"
                                v-on="on"
                              >
                                {{ medicalRequestItem.name | truncate(20) }}
                              </v-btn>
                            </template>

                            <span>
                              {{ medicalRequestItem.name }}
                            </span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>

              <v-tab-item key="treatment">
                <v-card color="background" flat>
                  <v-row :style="{ flexWrap: 'nowrap', overflowX: 'auto' }">
                    <v-col
                      cols="3"
                      v-for="(medicalRequestItemsCol,
                      index) in medicalRequestItemsTreatments"
                      :key="`medicalRequestItemsCol-${index}`"
                    >
                      <v-row
                        v-for="medicalRequestItem in medicalRequestItemsCol"
                        :key="medicalRequestItem.id"
                      >
                        <v-col>
                          <v-tooltip top max-width="450">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                :outlined="
                                  !selectedsItems.includes(medicalRequestItem)
                                "
                                :dark="
                                  selectedsItems.includes(medicalRequestItem)
                                "
                                block
                                rounded
                                color="light-blue"
                                @click="toggleItem(medicalRequestItem)"
                                :attrs="attrs"
                                v-on="on"
                              >
                                {{ medicalRequestItem.name | truncate(20) }}
                              </v-btn>
                            </template>

                            <span>
                              {{ medicalRequestItem.name }}
                            </span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>

              <v-tab-item key="surgery">
                <v-card color="background" flat>
                  <v-row :style="{ flexWrap: 'nowrap', overflowX: 'auto' }">
                    <v-col
                      cols="3"
                      v-for="(medicalRequestItemsCol,
                      index) in medicalRequestItemsSurgeries"
                      :key="`medicalRequestItemsCol-${index}`"
                    >
                      <v-row
                        v-for="medicalRequestItem in medicalRequestItemsCol"
                        :key="medicalRequestItem.id"
                      >
                        <v-col>
                          <v-tooltip top max-width="450">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                :outlined="
                                  !selectedsItems.includes(medicalRequestItem)
                                "
                                :dark="
                                  selectedsItems.includes(medicalRequestItem)
                                "
                                block
                                rounded
                                color="light-blue"
                                @click="toggleItem(medicalRequestItem)"
                                :attrs="attrs"
                                v-on="on"
                              >
                                {{ medicalRequestItem.name | truncate(20) }}
                              </v-btn>
                            </template>

                            <span>
                              {{ medicalRequestItem.name }}
                            </span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <MedicalRequestItems
      v-if="this.selectedsItems.length > 0"
      :medicalRequestItems="selectedsItems"
      :doctorUsers="doctorUsers"
      :sites="sites"
      :cid="cid"
      :observations="observations"
      :forwardTo="this.forwardTo"
      :site="site"
      :requester="this.requester"
      :reason="this.reason"
      :emergency="this.emergency"
      :attendance="this.attendance"
      :validateMedicalRequest="validateMedicalRequest"
    />
  </v-container>
</template>

<script>
import GET_MEDICAL_REQUEST_ITEM_FACILITATORS from "@/views/medical_requests/getMedicalRequestItemFacilitators.gql";

import QuerySearchDropdown from "@/components/ui/form/query_search_dropdown.vue";
import MedicalRequestItems from "@/components/medical_request/medical_request_item/edit_medical_request_item.vue";

export default {
  name: "MedicalRequest",
  props: {
    attendance: Object,
  },
  components: {
    MedicalRequestItems,
    QuerySearchDropdown,
  },
  data() {
    return {
      errors: {},
      requester: "",
      cid: "",
      forwardTo: "",
      observations: "",
      medicalRequestItems: [],
      selectedsItems: [],
      itemsFilter: "",
      medicalRequestItemFacilitator: null,
      medicalRequestType: "",
      reason: "",
      requestedQuantity: 2,
      emergency: false,
      site: "",
      sites: [
        "Olho direito",
        "Olho esquerdo",
        "Ambos os olhos",
        "Pálpebra direta",
        "Pálpebra esquerda",
        "Ambas pálpebras",
      ],
      getMedicalRequestItemFacilitatorsQuery: GET_MEDICAL_REQUEST_ITEM_FACILITATORS,
    };
  },
  apollo: {
    users: {
      query: require("@/graphql/users.gql"),
      result() {
        if (this.$store?.state?.authentication?.user?.id) {
          let userId = this.$store.state.authentication.user.id;

          this.requester = this.lodash.find(this.doctorUsers, {
            id: userId,
          });

          this.forwardTo = this.lodash.find(this.doctorUsers, {
            id: userId,
          })
        }
      },
    },
    diagnosticHypotheses: {
      query: require("@/graphql/diagnostic_hypotheses.gql"),
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
    },
    medicalRequestItems: {
      query: require("@/graphql/medical_request/medical_request_items.gql"),
      fetchPolicy: "no-cache",
      update(data) {
        return this.lodash.orderBy(data.medicalRequestItems, ["name"], ["asc"]);
      },
    },
  },
  computed: {
    doctorUsers() {
      return this.lodash.orderBy(
        this.lodash.filter(this.users, {
          employee: { employeeType: "doctor" },
        }),
        [
          (e) =>
            e.employee.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
        ],
        ["asc"]
      );
    },
    allDiagnosticHypotheses() {
      return this.lodash.filter(this.diagnosticHypotheses, {
        currentStatus: "active",
      });
    },
    onlyCids() {
      return this.allDiagnosticHypotheses.map(
        (diagnosticHypotheses) => diagnosticHypotheses.cid
      );
    },
    medicalRequestItemsCols() {
      return this.lodash.chunk(this.filteredMedicalRequestItems, 5);
    },
    medicalRequestItemsExams() {
      let medicalRequestItemsExams = this.lodash.filter(
        this.filteredMedicalRequestItems,
        {
          medicalRequestType: "exam",
        }
      );
      return this.lodash.chunk(medicalRequestItemsExams, 5);
    },
    medicalRequestItemsTreatments() {
      let medicalRequestItemsTreatments = this.lodash.filter(
        this.filteredMedicalRequestItems,
        {
          medicalRequestType: "treatment",
        }
      );
      return this.lodash.chunk(medicalRequestItemsTreatments, 2);
    },
    medicalRequestItemsSurgeries() {
      let medicalRequestItemsSurgeries = this.lodash.filter(
        this.filteredMedicalRequestItems,
        {
          medicalRequestType: "surgery",
        }
      );
      return this.lodash.chunk(medicalRequestItemsSurgeries, 5);
    },
    filteredMedicalRequestItems() {
      let medicalRequestItems = this.lodash.filter(this.medicalRequestItems, {
        visible: true,
      });

      if (this.itemsFilter) {
        medicalRequestItems = this.lodash.uniq(
          this.selectedsItems.concat(
            this.lodash.filter(
              medicalRequestItems,
              function(e) {
                return e.name
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .includes(
                    this.itemsFilter
                      .toLowerCase()
                      .normalize("NFD")
                      .replace(/[\u0300-\u036f]/g, "")
                  );
              }.bind(this)
            )
          )
        );
      }

      return medicalRequestItems;
    },
  },
  methods: {
    triggerFacilitator(facilitator) {
      if (!facilitator) return;

      this.$nextTick(() => {
        this.medicalRequestItemFacilitator = null;
      });

      this.addItemsToSelection(facilitator.items);
    },
    addItemsToSelection(items) {
      const itemIds = items.map((item) => item.id);

      // Required for item to show up in list
      const newSelectedItems = this.medicalRequestItems.filter(
        (selectableItem) => itemIds.includes(selectableItem.id)
      );

      this.selectedsItems = this.lodash.union(
        this.selectedsItems,
        newSelectedItems
      );
    },
    toggleItem(item) {
      this.selectedsItems = this.lodash.xor(this.selectedsItems, [item]);
    },
    clearSelectedItems() {
      this.selectedsItems = [];
    },
    changeCid() {
      if (this.cid?.description) {
        if (this.reason == null) {
          this.reason += this.cid?.description;
        } else {
          this.reason += " " + this.cid?.description;
        }
      }
    },
    changeSite() {
      if (this.site === "Ambos os olhos" || this.site === "Ambas pálpebras") {
        this.requestedQuantity = 2;
      } else {
        this.requestedQuantity = 1;
      }
    },

    validateMedicalRequest() {
      const errorMsg = "Esse campo deve ser preenchido.";
      this.errors = {};

      if (!this.requester?.id) {
        this.errors.requester = errorMsg;
      }

      if(!this.forwardTo?.id) {
        this.errors.forwardTo = errorMsg;
      }


      if (this.selectedsItems.length === 0) {
        this.errors.selectedsItems = "Selecione ao menos um exame";
      }

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="sass" scoped></style>
